import { render, staticRenderFns } from "./ConfigAlertAlertmanager.vue?vue&type=template&id=eaedd1f4"
import script from "./ConfigAlertAlertmanager.vue?vue&type=script&lang=js"
export * from "./ConfigAlertAlertmanager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports